<template>
  <transition name="loading-overlay__transition">
    <div class="text-light justify-content-center loading-overlay" v-if="show">
      <div class="spinner-border align-self-center" style="width: 5rem; height: 5rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </transition>
</template>

<script>
import {isLoading} from "@/components/LoadingOverlay/loadingOverlayControl";

export default {
  name: "LoadingOverlay",
  setup() {
    const show = isLoading;

    return {
      show
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables';

.loading-overlay {
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: $poketwitch-header-height;
  z-index: 100;

  &__transition {
    &-enter-active, &-leave-active {
      transition: all .3s;
    }

    &-enter-from, &-leave-to {
      opacity: 0;
    }
  }
}
</style>